import { useState, useEffect } from "react";
import { useMachine } from "@xstate/react";
import { FormTemplate } from "../../FormTemplate/FormTemplate";
import { ownerRegisterMachine } from "@/js/xstate/ownerRegister.machine";
import { SuccessPopup } from "@/js/modules/SuccessPopup/SuccessPopup";
import { Tooltip } from "react-tooltip";
import { Icon } from "../../../SVGsprite/svgsprite";

export function OwnerRegisterForm() {
	const [stateOwner, sendOwner] = useMachine(ownerRegisterMachine);
	const [isSuccessPopup, setSuccessPopup] = useState(false);
	const [isTooltipVisible, setTooltipVisible] = useState(false);
	const [emailError, setEmailError] = useState("");

	const handleSubmit = event => {
		event.preventDefault();

		// Проверяем email перед отправкой
		const email = stateOwner.context.email;
		if (
			email &&
			!email.endsWith(".ru") &&
			!email.endsWith("@sportavto.com") &&
			!email.endsWith("@essmo.org") &&
			!email.endsWith("@makk.club") &&
			!email.endsWith("@zamena.org")
		) {
			setEmailError(
				"На портале можно зарегистрироваться только с почтой в зоне .ru",
			);
			return; // Не отправляем форму
		}

		setEmailError(""); // Очищаем ошибку
		sendOwner({ type: "SUBMIT" });
	};

	const toggleTooltip = () => {
		setTooltipVisible(!isTooltipVisible);
	};

	const closeTooltip = () => {
		setTooltipVisible(false);
	};

	useEffect(() => {
		setSuccessPopup(Boolean(stateOwner.context.message));
	}, [stateOwner.context.message]);

	useEffect(() => {
		document.title = "Зарегистрировать Партнера | Программа лояльности SK ZIC";
	}, []);

	// Очищаем ошибку при изменении email
	const handleEmailChange = event => {
		setEmailError(""); // Очищаем ошибку при вводе
		sendOwner({
			type: "INPUT_EMAIL",
			key: "email",
			data: event.target.value,
		});
	};

	return (
		<FormTemplate title="Зарегистрировать Партнера ТТ" isLoading={false}>
			{stateOwner.context.errorMessage.map(
				item =>
					item.serverError &&
					item.serverError !== "" && (
						<div className="errorMessage" key="errName">
							{item.serverError}
						</div>
					),
			)}

			<form onSubmit={handleSubmit}>
				<div className="formRow">
					<label htmlFor="name">Имя</label>
					<input
						id="name"
						type="text"
						name="name"
						value={stateOwner.context.name}
						onChange={event => {
							sendOwner({
								type: "INPUT_NAME",
								key: "name",
								data: event.target.value,
							});
						}}
					/>
					{stateOwner.context.errorMessage.map(
						item =>
							item.nameError &&
							item.nameError !== "" && (
								<div className="errorMessage" key="errName">
									{item.nameError}
								</div>
							),
					)}
				</div>
				<div className="formRow">
					<label htmlFor="surname">Фамилия</label>
					<input
						id="surname"
						type="text"
						name="surname"
						value={stateOwner.context.surname}
						onChange={event => {
							sendOwner({
								type: "INPUT_SURNAME",
								key: "surname",
								data: event.target.value,
							});
						}}
					/>
					{stateOwner.context.errorMessage.map(
						item =>
							item.surnameError &&
							item.surnameError !== "" && (
								<div className="errorMessage" key="errSurname">
									{item.surnameError}
								</div>
							),
					)}
				</div>
				<div className="formRow">
					<label htmlFor="email" className="email_form_warning">
						E-mail
						<div className="tooltip_custom_warning" onClick={toggleTooltip}>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								style={{ cursor: "pointer" }}
							>
								<rect width="20" height="20" rx="10" fill="#B83436" />
								<path
									d="M10.7578 4.125L10.6562 12.2891H9.35156L9.24219 4.125H10.7578ZM9.19531 14.7734C9.19531 14.5391 9.26562 14.3411 9.40625 14.1797C9.55208 14.0182 9.76562 13.9375 10.0469 13.9375C10.3229 13.9375 10.5339 14.0182 10.6797 14.1797C10.8307 14.3411 10.9062 14.5391 10.9062 14.7734C10.9062 14.9974 10.8307 15.1901 10.6797 15.3516C10.5339 15.513 10.3229 15.5938 10.0469 15.5938C9.76562 15.5938 9.55208 15.513 9.40625 15.3516C9.26562 15.1901 9.19531 14.9974 9.19531 14.7734Z"
									fill="white"
								/>
							</svg>
							{isTooltipVisible && (
								<div className="tooltip_custom_warning--message">
									<p>
										Регистрация на сайте доступна только для почтовых адресов на
										российских доменах (@mail.ru, @yandex.ru, @bk.ru, @inbox.ru
										и др.)
									</p>
									<button
										type="button"
										className="modalClose"
										style={{ marginLeft: "auto" }}
										onClick={closeTooltip}
									>
										<Icon name="icon-close" sizeW="20" sizeH="20" />
										<span className="visuallyHidden">Закрыть</span>
									</button>
								</div>
							)}
						</div>
					</label>
					<input
						id="email"
						type="text"
						name="email"
						value={stateOwner.context.email}
						onChange={handleEmailChange}
					/>
					{/* Ошибки от валидации */}
					{stateOwner.context.errorMessage.map(
						item =>
							item.emailError &&
							item.emailError !== "" && (
								<div className="errorMessage" key="errEmail">
									{item.emailError}
								</div>
							),
					)}
					{/* Ошибка проверки .ru */}
					{emailError && (
						<div className="errorMessage" style={{ color: "#B83436" }}>
							{emailError}
						</div>
					)}
				</div>
				<div className="formRow">
					<label htmlFor="phone">Телефон</label>
					<input
						id="phone"
						type="text"
						name="phone"
						value={stateOwner.context.phone}
						onChange={event => {
							sendOwner({
								type: "INPUT_PHONE",
								key: "phone",
								data: event.target.value,
							});
						}}
					/>
					{stateOwner.context.errorMessage.map(
						item =>
							item.phoneError &&
							item.phoneError !== "" && (
								<div className="errorMessage" key="errPhone">
									{item.phoneError}
								</div>
							),
					)}
				</div>
				<div className="formRow">
					<button type="submit" className="btn btnPrimary">
						Зарегистрировать
					</button>
				</div>
			</form>
			<SuccessPopup
				isOpen={isSuccessPopup}
				onClose={() => setSuccessPopup(false)}
				title={stateOwner.context.message}
			/>
		</FormTemplate>
	);
}
